import ButtonTypes from 'containers/Learn/Articles/ButtonTypes';
import { ImageCroppings } from 'containers/Learn/Articles/ImageCroppings';
import { MediaTypes } from 'containers/Training/Layouts/MediaTypes';
import { IArticle, IArticleContainer } from 'interfaces/IArticle';
import translate from 'translate';
import { api } from './api';

export const articleApi = api.injectEndpoints({
  endpoints: (build) => ({
    getArticle: build.query<IArticle, { articleId: string }>({
      query: ({ articleId }) => ({
        url: `Articles/${articleId}`,
      }),
      extraOptions: { maxRetries: 0 },
    }),
    getArticleContainer: build.query<
      IArticleContainer,
      { articleContainerId: string }
    >({
      query: ({ articleContainerId }) => ({
        url: `Articles/containers/${articleContainerId}`,
      }),
      transformResponse: (response: IArticleContainer) => ({
        ...response,
        contentSection: response.articles.map((article) => ({
          buttons: [
            {
              title: translate('General_ReadMore'),
              type: ButtonTypes.NavigationLink,
              navigationLink: `/learn/article/${article.urlName}`,
            },
          ],
          croppingSize: ImageCroppings.Wide,
          id: article.id,
          layout: 'Top',
          longDescription: article.intro,
          media: article.hero,
          mediaType: MediaTypes.IMAGE,
          title: article.title,
        })),
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useGetArticleQuery, useGetArticleContainerQuery } = articleApi;

export const {
  endpoints: { getArticle, getArticleContainer },
} = articleApi;
